
      import API from "!../../style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../css-loader/dist/cjs.js??ruleSet[1].rules[4].use[1]!./virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"app/components/book-delivery/styles.css.ts.vanilla.css\",\"source\":\"Ll8xbm95YWQ0MCB7CiAgd2lkdGg6IDMyNXB4Owp9Ci5fMW5veWFkNDEgewogIHdpZHRoOiAxMDAlOwp9CkBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6IDc2OHB4KSB7CiAgLl8xbm95YWQ0MCB7CiAgICB3aWR0aDogaW5pdGlhbDsKICB9CiAgLl8xbm95YWQ0MSB7CiAgICBtaW4td2lkdGg6IDE4MHB4OwogICAgd2lkdGg6IGluaXRpYWw7CiAgfQogIC5fMW5veWFkNDIgewogICAgbWluLWhlaWdodDogOTRweDsKICB9CiAgLl8xbm95YWQ0MyB7CiAgICBtYXgtd2lkdGg6IDE4MHB4OwogIH0KfQ==\"}!./extracted.js";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../css-loader/dist/cjs.js??ruleSet[1].rules[4].use[1]!./virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"app/components/book-delivery/styles.css.ts.vanilla.css\",\"source\":\"Ll8xbm95YWQ0MCB7CiAgd2lkdGg6IDMyNXB4Owp9Ci5fMW5veWFkNDEgewogIHdpZHRoOiAxMDAlOwp9CkBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6IDc2OHB4KSB7CiAgLl8xbm95YWQ0MCB7CiAgICB3aWR0aDogaW5pdGlhbDsKICB9CiAgLl8xbm95YWQ0MSB7CiAgICBtaW4td2lkdGg6IDE4MHB4OwogICAgd2lkdGg6IGluaXRpYWw7CiAgfQogIC5fMW5veWFkNDIgewogICAgbWluLWhlaWdodDogOTRweDsKICB9CiAgLl8xbm95YWQ0MyB7CiAgICBtYXgtd2lkdGg6IDE4MHB4OwogIH0KfQ==\"}!./extracted.js";
       export default content && content.locals ? content.locals : undefined;
